import CheckboxField from './CheckboxField'
export default CheckboxField



// WEBPACK FOOTER //
// ./src/components/forms/CheckboxField/index.js